<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="YongHuList" data-title="用户管理">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="flex-1 overflow-hidden flex gap-x-3 mt-2">
      <c_bumen
        @node-change="
          (id) => {
            state.params.department_id = id;
            onLoad();
          }
        "
      />
      <div class="content">
        <el-checkbox-group v-model="state.selectIds">
          <el-table
            :data="state.tableData"
            v-loading="!Array.isArray(state.tableData)"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            :default-sort="{
              prop: state.params.sort_field,
              order:
                state.params.sort_value == 'desc' ? 'descending' : 'ascending',
            }"
            @sort-change="onSortChange"
          >
            <el-table-column fixed width="70">
              <template #header>#</template>
              <template #default="{ row }">
                <el-checkbox
                  :value="row.id"
                  :checked="
                    row.admin_role_id
                      ?.split(',')
                      .includes(props.role_id.toString())
                  "
                  @change="onSelect($event, row.id)"
                />
              </template>
            </el-table-column>
            <el-table-column :width="140">
              <template #header>
                <div class="c-table-col-header" label1="姓名" label2="性别" />
              </template>
              <template #default="{ row }">
                <div class="flex items-center gap-x-1">
                  <strong>{{ row.name }}</strong>
                  <el-icon v-if="row.sex == '男'"
                    ><Male color="#1e90ff"
                  /></el-icon>
                  <el-icon v-else style="transform: rotate(180deg)"
                    ><Male color="#f00"
                  /></el-icon>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="所属部门"
              prop="department_name"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="手机号"
              prop="phone"
              :formatter="$tab_TextFormat"
            />
            <el-table-column
              label="角色"
              prop="admin_role_name"
              :formatter="$tab_TextFormat"
              :min-width="160"
            />
            <el-table-column
              label="职务"
              prop="job"
              :formatter="$tab_TextFormat"
            />
            <el-table-column label="管理员" align="center">
              <template #default="{ row }">
                <text v-if="row.is_super_auth" class="text-green-600">是</text>
                <text v-else class="text-red-600">否</text>
              </template>
            </el-table-column>
          </el-table>
          <c_page
            :total="state.totalCount"
            :pageIndex="state.params.page"
            :pageSize="state.params.limit"
            @onLoad="
              (page) => {
                state.params.page = page.pageIndex;
                state.params.limit = page.pageSize;
                onLoad();
              }
            "
          />
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { data_getAdmin_page } from "@/http/data";
import { adminRole_bindAdmin } from "@/http/adminRole";

import c_bumen from "../BuMen/Tree.vue";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    role_id: Number,
  },
  components: {
    c_bumen,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
      selectIds: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      data_getAdmin_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
          setTimeout(() => {
            state.key = Math.random();
          }, 1000);
        }
      });
    };

    const onSelect = (e, id) => {
      adminRole_bindAdmin({
        id: props.role_id,
        admin_id: id,
        checked: e,
      })
        .then((res) => {
          if (res.status == 200) {
            ElMessage({
              type: "success",
              message: res.data?.msg,
              grouping: true,
            });
            onLoad();
          } else {
            state.selectIds = state.selectIds.filter((w) => w != id);
          }
        })
        .catch(() => {
          state.selectIds = state.selectIds.filter((w) => w != id);
        });
    };

    return { state, props, onLoad, onSelect };
  },
};
</script>

<style lang="scss" scoped></style>
